import { testimonials } from '@/mocks/home';

export default function Testimonials() {
  return (
    <section className="py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            用户好评如潮
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            来自真实用户的肯定，是我们不断前进的动力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-xl p-6">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                &ldquo;{item.comment}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}